// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Auth_wrapper__hVSPQ","form":"Auth_form__1DODJ","form__text":"Auth_form__text__pV47K","form__info":"Auth_form__info__2T9s9","form__error":"Auth_form__error__144uo"};